import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useLocation } from "react-router-dom";
import Navbar from "../componenet/Navbar";
import Lightbox from "yet-another-react-lightbox";
import Captions from "yet-another-react-lightbox/plugins/captions";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";
import { HiLockClosed, HiArrowLeft, HiShoppingCart, HiCheckCircle, HiPlusCircle } from "react-icons/hi";

const Home = () => {
  const [index, setIndex] = useState(-1);
  const { shareId } = useParams();
  const location = useLocation();
  const [isAuthorized, setIsAuthorized] = useState(true);
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);

  const isSummaryView = location.pathname.includes('/view/') && (!isNaN(shareId) || shareId.includes(','));

  const API_BASE = "https://api.zunoor.cloud/api";
  const IMG_BASE = "https://api.zunoor.cloud/";

  useEffect(() => {
    if (!shareId) {
      setLoading(false);
      setIsAuthorized(false);
      return;
    }

    const loadData = async () => {
      try {
        let res;
        const isProductPath = !isNaN(shareId) || shareId.includes(',');
        if (isProductPath) {
          res = await axios.get(`${API_BASE}/product/${shareId}`);
        } else {
          res = await axios.get(`${API_BASE}/view/collection/${shareId}`);
        }

        if (res.data) {
          const dataArray = Array.isArray(res.data) ? res.data : [res.data];
          const formattedProducts = dataArray.map((p) => ({
            id: p.id,
            src: `${IMG_BASE}${p.image_path.replace(/\\/g, '/')}`,
            title: `Design: ${p.design_no}`,
            designNo: p.design_no,
            variants: typeof p.variants === 'string' 
                ? p.variants.split(',').map(v => {
                    const [size, rate] = v.split(':');
                    return { size, rate };
                  }) 
                : (p.variants || []),
          }));
          setProducts(formattedProducts);
          setIsAuthorized(true);
        }
      } catch (error) {
        setIsAuthorized(false);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, [shareId]);

  const toggleSelect = (e, item) => {
    if(e) e.stopPropagation();
    if(!item || isSummaryView) return; 
    setSelectedItems(prev => {
      const isExisting = prev.find(i => i.id === item.id);
      return isExisting ? prev.filter(i => i.id !== item.id) : [...prev, item];
    });
  };

  const getWaLink = (items) => {
    const targetItems = Array.isArray(items) ? items : [items];
    const idString = targetItems.map(i => i.id).join(',');
    const previewLink = `https://api.zunoor.cloud/order-preview/${idString}`;
    const message = encodeURIComponent(
      `🛍️ *NEW ORDER REQUEST*\n\n` +
      `Design(s): ${targetItems.map(i => i.designNo).join(', ')}\n\n` +
      `View Details: ${previewLink}`
    );
    return `https://wa.me/917878497980?text=${message}`;
  };

  if (loading) return <div className="vh-100 d-flex align-items-center justify-content-center bg-white"><div className="spinner-grow text-danger"></div></div>;

  return (
    <div style={{ backgroundColor: "#fafafa", minHeight: "100vh", fontFamily: "'Inter', sans-serif" }}>
      <Navbar />
      
      <div className="container py-4">
        <div className="text-center mb-4">
          <h1 className="fw-bold mb-2" style={{ color: "#1a1a1a" }}>
            {isSummaryView ? "Order" : "Exclusive"} <span style={{ color: "#8B3232" }}>{isSummaryView ? "Summary" : "Arrivals"}</span>
          </h1>
          <div className="mx-auto" style={{ width: "50px", height: "3px", backgroundColor: "#8B3232" }}></div>
        </div>

        <div className="row g-3 px-1">
          {products.map((item, i) => {
            const isSelected = selectedItems.find(s => s.id === item.id);
            return (
              <div key={item.id} className="col-12 col-md-6 col-lg-3">
                <div className="card border-0 product-card h-100 shadow-sm">
                  <div className="position-relative overflow-hidden" style={{ cursor: "pointer", borderRadius: "12px 12px 0 0" }} onClick={() => setIndex(i)}>
                    {!isSummaryView && (
                      <div className={`selection-check ${isSelected ? 'active' : ''}`} onClick={(e) => toggleSelect(e, item)}>
                        <HiCheckCircle size={28} />
                      </div>
                    )}
                    <img 
                        src={item.src} 
                        className="w-100 product-img clarity-boost" 
                        style={{ objectFit: "cover", display: 'block' }} 
                        alt={item.title}
                    />
                    <div className="design-badge"># {item.designNo}</div>
                  </div>

                  <div className="p-3 bg-white" style={{ borderRadius: "0 0 12px 12px" }}>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span className="text-muted small fw-bold">DESIGN: {item.designNo}</span>
                      <span className="fw-bold text-success small" style={{ fontSize: '0.65rem' }}>● READY TO SHIP</span>
                    </div>

                    <div className="mb-3 border rounded p-2 bg-light">
                      {item.variants.map((v, idx) => (
                        <div key={idx} className="d-flex justify-content-between small py-1 border-bottom-dashed">
                          <span className="text-dark fw-semibold">{v.size}</span>
                          <span className="fw-bold text-danger">₹{v.rate}</span>
                        </div>
                      ))}
                    </div>

                    <button onClick={(e) => toggleSelect(e, item)} className={`btn w-100 py-2 fw-bold ${isSelected ? 'btn-dark' : 'wa-premium-btn'}`}>
                      {isSelected ? 'REMOVE FROM ORDER' : <><HiShoppingCart className="me-2" /> ADD TO ORDER</>}
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {selectedItems.length > 0 && !isSummaryView && (
        <div className="fixed-bottom p-3" style={{ zIndex: 1050 }}>
          <div className="container bg-dark text-white p-3 rounded-pill shadow-lg d-flex justify-content-between align-items-center">
            <div className="ps-3 fw-bold">{selectedItems.length} Selected</div>
            <a href={getWaLink(selectedItems)} target="_blank" className="btn btn-success rounded-pill px-4 fw-bold" style={{backgroundColor: '#25D366', border: 'none'}}>CONFIRM ORDER</a>
          </div>
        </div>
      )}

      <Lightbox
        index={index}
        open={index >= 0}
        close={() => setIndex(-1)}
        slides={products}
        plugins={[Zoom, Captions]}
        // Optimization for professional clarity
        zoom={{ scrollToZoom: true, maxZoomPixelRatio: 3 }}
        on={{ view: ({ index: currentIndex }) => setIndex(currentIndex) }}
        render={{
          header: () => {
            const currentItem = products[index];
            if (!currentItem) return null;
            const isSelected = selectedItems.find(s => s.id === currentItem.id);
            return (
              <div className="wa-header">
                <div className="d-flex justify-content-between align-items-center w-100">
                    <div className="d-flex align-items-center">
                        <button className="wa-back-btn" onClick={() => setIndex(-1)}><HiArrowLeft size={24} /></button>
                        <div className="ms-3 text-white fw-bold">Design: {currentItem.designNo}</div>
                    </div>
                    {!isSummaryView && (
                        <button 
                            className={`btn btn-sm rounded-pill px-4 fw-bold ${isSelected ? 'btn-success' : 'btn-light'}`}
                            onClick={() => toggleSelect(null, currentItem)}
                        >
                            {isSelected ? '✓ SELECTED' : '+ ADD TO ORDER'}
                        </button>
                    )}
                </div>
              </div>
            );
          },
          controls: () => {
            const currentItem = products[index];
            if (!currentItem) return null;
            return (
              <div className="wa-footer">
                <div className="container d-flex flex-column align-items-center gap-3">
                  <div className="d-flex gap-2 flex-wrap justify-content-center">
                    {currentItem.variants.map((v, idx) => (
                      <div key={idx} className="variant-pill">
                        <span className="v-size">{v.size}</span>
                        <span className="v-price">₹{v.rate}</span>
                      </div>
                    ))}
                  </div>
                  <a href={getWaLink(currentItem)} target="_blank" className="btn btn-success rounded-pill px-5 fw-bold" style={{backgroundColor: '#25D366', border: 'none'}}>
                    <HiShoppingCart className="me-2"/> PLACE ORDER NOW
                  </a>
                </div>
              </div>
            );
          }
        }}
      />

      <style>{`
        /* Professional Clarity Boosters */
        .clarity-boost {
            image-rendering: -webkit-optimize-contrast;
            image-rendering: crisp-edges;
            backface-visibility: hidden;
            transform: translateZ(0);
        }

        .product-card { border-radius: 12px; overflow: hidden; transition: 0.3s; }
        .product-img { height: 450px; }
        
        /* Mobile Height Optimization */
        @media (max-width: 768px) {
          .product-img { height: 380px; }
        }

        .design-badge { position: absolute; top: 12px; left: 12px; background: #8B3232; color: white; padding: 4px 12px; border-radius: 5px; font-weight: 800; font-size: 0.7rem; z-index:2; }
        .selection-check { position: absolute; top: 12px; right: 12px; color: rgba(255,255,255,0.8); z-index: 10; cursor: pointer; }
        .selection-check.active { color: #25D366; }
        .wa-premium-btn { background: #25D366; color: white; border-radius: 8px; font-weight: 800; border: none; }
        .wa-header { position: absolute; top:0; left:0; right:0; padding:20px; background: linear-gradient(to bottom, rgba(0,0,0,0.8), transparent); z-index:10; }
        .wa-footer { position: absolute; bottom:0; left:0; right:0; padding: 30px 20px; background: linear-gradient(to top, rgba(0,0,0,0.9), transparent); z-index:10; }
        .variant-pill { background: rgba(255,255,255,0.1); border-radius: 6px; display: flex; color: white; font-size: 0.8rem; border: 1px solid rgba(255,255,255,0.2); overflow: hidden; backdrop-filter: blur(5px); }
        .v-size { padding: 4px 10px; background: rgba(255,255,255,0.1); }
        .v-price { padding: 4px 10px; color: #25D366; font-weight: 800; }
        .wa-back-btn { background:none; border:none; color:white; }
        .border-bottom-dashed { border-bottom: 1px dashed #eee; }
        
        /* Lightbox Clarity Adjustment */
        .yarl__slide_image {
            image-rendering: -webkit-optimize-contrast !important;
            image-rendering: auto !important;
            -ms-interpolation-mode: bicubic !important;
        }
      `}</style>
    </div>
  );
};

export default Home;